import React from 'react';
import style from './interiorBox.scss';
import Price from '../../util/Price';

function InteriorBox(props) {
    const { item, selectedItems, onSelectItem, markedDependencies } = props;

    let isSelected = false;
    let isMarked = false;
    let containerStyle = style.container;
    let serialParentUid = 0;

    for (let i = 0; i < selectedItems.length; i += 1) {
        if (selectedItems[i].uid === item.uid) {
            isSelected = true;
            serialParentUid = selectedItems[i].serial_parent_uid;
        }
    }

    if (isSelected) {
        containerStyle = style.container__active;
    }

    for (let i = 0; i < markedDependencies.length; i += 1) {
        if (markedDependencies[i] === item.uid) {
            isMarked = true;
        }
    }

    if (isMarked) {
        containerStyle += ` ${style.container__marked}`;
    }

    const onChange = () => {
        if (item.mandatory) {
            return null;
        }
        return onSelectItem(item);
    };

    return (
        <label htmlFor={item.uid}>
            <input className={style.radio} type="radio" value={item.uid} id={item.uid} checked={isSelected} onClick={() => onChange()} />
            <div className={containerStyle}>
                <div>
                    <img className={style.image} src={`/${item.image}`} alt={item.name} />
                </div>
                <div className={style.details}>
                    <p className={style.title}>{item.name}</p>
                    <h4 className={style.price}>
                        + <Price value={props.resolvePrice(item, serialParentUid)} />
                    </h4>
                </div>
            </div>
        </label>
    );
}
export default InteriorBox;
